import { render } from "./ViewPrvComponent.vue?vue&type=template&id=185fc737"
import script from "./ViewPrvComponent.vue?vue&type=script&lang=js"
export * from "./ViewPrvComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__